<div class="container-fluid" >
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title">Lista de Notas |
          <span style="color: #016E97;">{{nombre_oferta}}</span> - <span style="color: #016E97;">{{uc_pre_impreso}}</span>
        </h3>
      </div>
    </div>
  </div>

    <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
        <div class="card" style="border-color: white;">
          <div class="card-body" style="margin-bottom: 150px;">
            <!-- Invoice Logo -->
            <!--div class="row">
              <div class="col-md-6">
                <label for="estadol" class="col-form-label">Busqueda</label>
                <input
                  class="form-control"
                  type="text"
                  id="buscar"
                  placeholder="Buscar estudiante..."
                  [(ngModel)]="searchTerm"
                  (input)="buscarAccionFormativa()"
                >
              </div>
            </div>
            <hr class="text-dark"-->
            <!-- Invoice Logo -->
            <div class="row" [formGroup]="formularioNotas" id="formularioNotas">
              <div class="col-12">
                <table class="table">
                  <thead>
                    <tr class="table-primary">
                      <th scope="col">N°</th>
                      <th class="text-center">Nombres Completo </th>
                      <ng-container *ngFor="let r of cabecera.evaluacion;">
                        <th class="text-center">{{r.logro}}({{r.porcentaje_evaluacion}}%) </th>
                      </ng-container>
                      <th class="text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody formArrayName="participantes">
                    <ng-container *ngFor="let r of filteredResultado; let i = index" [formGroupName]="i">
                      <tr>
                        <td scope="row">{{i+1}}</td>
                        <td class="text-center">{{r.nombres_apellidos}}</td>

                        <ng-container formArrayName="notas">

                          <ng-container *ngFor="let a of r.evaluacion; let o = index">
                            <td [formGroupName]="o">
                              <div class="form-check form-switch">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="nota-{{i}}-{{o}}"
                                  name="nota-{{i}}-{{o}}"
                                  placeholder="nota"
                                  formControlName="nota"
                                  mask="99"
                                  [value]="r.nota == null ? 0 : r.nota"
                                  (input)="calcula(i, o, $event.target)"
                                >
                              </div>
                            </td>
                          </ng-container>
                        </ng-container>

                        <td class="text-center">{{r.total_nota}}%</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 text-center">
                <button type="button" class="btn btn-lg btn-primary" (click)="confirmacion()">Aceptar</button>
              </div>
            </div>
          </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>


</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje" (saveModal)="guardar_todo()"></app-modal>
